<template>
    <div id="btn">
      <p class="completion-graph__title">{{this.report.sectionName}}
        <span>
          <img v-if="this.report.diffType=='up'" src="@/assets/img/common/up.svg" alt="">
          <img v-else-if="this.report.diffType=='down'" src="@/assets/img/common/down.svg" alt="">
        </span>
      </p>
      <div class="completion-graph__graph">
        <div :id="this.report.num" class="completion-graph-donut js-donut-graph" :data-percent="this.report.percentage" :data-color="this.report.color">
          <p class="completion-graph-donut__text">
            <span class="completion-graph-donut__number"></span>
            <span class="completion-graph-donut__unit">{{this.report.unit}}</span>
          </p>
        </div>
      </div>
      <div class="completion-graph__detail">
        <p class="completion-graph__detail-header">IPO重要度(%)</p>
        <div class="completion-graph__detail-body">
          <p><span>Lv.1</span><span style="font-weight: 600" v-if="this.report.reportIpo1!=null">{{this.report.reportIpo1}}</span><span v-else> --- </span></p>
          <p><span>Lv.2</span><span style="font-weight: 600" v-if="this.report.reportIpo2!=null">{{this.report.reportIpo2}}</span><span v-else> --- </span></p>
          <p><span>Lv.3</span><span style="font-weight: 600" v-if="this.report.reportIpo3!=null">{{this.report.reportIpo3}}</span><span v-else> --- </span></p>
          <p><span>Lv.4</span><span style="font-weight: 600" v-if="this.report.reportIpo4!=null">{{this.report.reportIpo4}}</span><span v-else> --- </span></p>
        </div>
      </div>
    </div>
</template>

<!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.3/jquery.min.js"></script>-->
<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>

import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    report:{},
  },
  data() {
    return {
    }
  },
  created: function() {
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
  },
  mounted: function() {

    jQuery(function ($) {
      $('#btn').click(function() {
//        $("#hogehoge").text("テキスト挿入");
      });

      // inviewイベントを使用して円グラフを初期化
      $('.js-donut-graph').each(function(index) {
        var g = $('.js-donut-graph');
        var $this = $('#completion-graph-donut-'+index);
        var percent = $(this).data('percent');
        var color = $(this).data('color'); // 色を取得
        // 数値と色を設定
        $(this).find('.completion-graph-donut__number').text(0);
        $(this).find('.completion-graph-donut__unit').text('%');
        $this.css('--graph-color', color); // CSS変数に色を設定
        $({ Counter: 0 }).animate({ Counter: percent }, {
          duration: 500,
          easing: 'swing',
          step: function() {
            $this.css('--percent', Math.ceil(this.Counter) + '%');
            $this.find('.completion-graph-donut__number').text(Math.ceil(this.Counter));
          }
        });
      });
    })
  },
  methods: {
    /**
     * 年度ラベル取得　最新年度から５年分
     */
    async getYearLabels(corpId, year) {
      let res = await this.$axios.post('/ld/api/hr/getYearLabels', {corpId:corpId, year: year });
      if (res) {
        this.lineChartData.labels = res.data.labels;
      }
    },
    /**
     * 労災発生件数取得
     */
    async getHumanCapitalLineChartData(corpId, year) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/hr/getHumanCapitalLineChartData', {
          hrType: 8, // 8:労災発生件数
          corpId:corpId, 
          year: year
        });
        if (res) {
          let unit = '件';
          let goalValue = (res.data.dataset2[0]);
          let tmp = res.data.dataset1.slice();
          tmp.push(goalValue);

          let cleanedData = tmp.filter(x => x !== null);
          let min1401 = 0;
          let max1401 = Math.round(Math.max.apply(null, cleanedData) + 1);
          let stepsize1401= Math.round((max1401 - min1401) / 5);

          let datasets = [];
          let dataset = {
            data: res.data.dataset1, // データ配列（実績）
            label: '実績', // データ名称
            borderWidth: 4, // ラインの太さ
            fill: false, // ライン以下の領域を塗りつぶすかどうか
            lineTension	: 0, // 滑らかな曲線設定　0:直線
            borderColor: "#0072c4", // ライン色
            pointBackgroundColor: function(context) { // 指標点の背景色
                let index = context.dataIndex;
                let count = context.dataset.data.length - 1;
                return index === count ? '#0072c4' : '#0072c4';
            },
            pointRadius: function(context) {　// 指標点の形状設定
                let index = context.dataIndex;
                let count = context.dataset.data.length - 1;
                return index === count ? 8 : 4;
            }
          };
          datasets.push(dataset);

          let dataset2 = {
            data: res.data.dataset2, // データ配列（実績）
            label: "目標", // データ名称
            borderWidth: 2, // ラインの太さ
            fill: false, //ライン以下の領域を塗りつぶすかどうか
            lineTension	: 0, //滑らかな曲線設定 0:直線
            borderColor: "#ff6384", // ライン色
            pointRadius: -1, // ポイント非表示
          };
          datasets.push(dataset2);
          this.lineChartData.datasets = datasets;

          let options = {
            legend: {
              position: 'left',
              display: false,
            },
            responsive: true,
            maintainAspectRatio: false,
            hover: {
              mode: 'index',
              intersec: false
            },
            scales: {
              // X-Axis
              xAxes: [{
                display: true,
                gridLines: {
                  display:true
                },
              }],
              // Y-Axis
              yAxes: [{
                display: true,
                position: 'left',
                ticks: {
                  min:min1401,
                  max:max1401,
                  stepSize:stepsize1401,
                  maxTicksLimit: 10,
                  callback: (value) => `${value}` + unit,
                },
              }]
            }, // scales end
            tooltips : {
              callbacks: {
                title(tooltipItem, data) {
                  const idx = tooltipItem[0].index;
                  const title = data.labels[idx];
                  return title;
                },
                label(tooltipItem, data) {
                  const idx = tooltipItem.datasetIndex;
                  const label = data.datasets[idx].label;
                  return label + ':' + tooltipItem.value + unit;
                }
              }
            }, // tooltips end
          };
          this.lineChartOptions = options;
        }
      }
    },
    /**
     * LineChartの再描画処理
     */
    async recreateChart(corpId, year) {
      await this.getYearLabels(corpId, year);
      await this.getHumanCapitalLineChartData(corpId, year);
      this.$refs.chart.reRenderChart(this.lineChartData, this.lineChartOptions)
    },
  },
}
</script>

<style scoped>
.chart-area {
  border: 2px solid rgba(220, 220, 220, 0.5);
  border-radius: 10px;
  padding: 10px;
  background-color: rgba(248, 248, 255, 0.5);
}
</style>